/*jshint loopfunc: true */
define('editor/edit/layers/edit/marker',['./layerBase', 'knockout', 'knockout-mapping', 'plugins/http', 'durandal/app', 'jquery', './markerStyleTracker', 'tinycolorpicker'], function (layerBase, ko, komapping, http, app, $, markerStyleTracker) {
  var viewmodel = function () {
    var self = this;

    var moduleId = self.__moduleId__;
    self.base = new layerBase();
    $.extend(self, self.base);
    self.__moduleId__ = moduleId;

    self.icons = ko.observableArray([]);

    self.selectedIcon = ko.observable();
    self.iconVisible = ko.observable();
    self.selectedIconSize = ko.observableArray([]);
    self.selectedTextSize = ko.observableArray([]);
    self.selectedAlignment = ko.observableArray([]);
    self.iconColour = ko.observable();
    self.paddleVisible = ko.observable(false);
    self.paddleColour = ko.observable();
    self.labelText = ko.observable('');
    self.labelTextColor = ko.observable();
    self.labelShadowColor = ko.observable();
    self.labelVisible = ko.observable(true);
    self.lat = ko.observable();
    self.lon = ko.observable();
    self.choosingIcon = ko.observable(false);

    self.activate = function (editorMapId, layer, backToListFunc) {
      self.layer = layer;
      self.base.activate(editorMapId, layer, backToListFunc);

      self.getIcons()
          .then(self.processIcons)
          .fail(app.showError);

      // properties
      self.selectedIcon(self.layer.state().selectedicon());
      self.iconVisible(self.layer.state().visibilityOptions.iconVisible());
      self.selectedIconSize.push(self.layer.state().iconSize());
      self.selectedTextSize.push(self.layer.state().textSize());
      self.selectedAlignment.push(self.layer.state().textAlign());
      self.iconColour(self.layer.state().iconColour());
      self.paddleVisible(self.layer.state().visibilityOptions.paddleVisible());
      self.paddleColour(self.layer.state().paddleColour());
      self.labelText(self.layer.state().html());
      self.labelTextColor(self.layer.state().labelTextColor());
      self.labelShadowColor(self.layer.state().textShadowColour());
      self.labelVisible(self.layer.state().visibilityOptions.labelVisible());
      self.lat(self.layer.state().geometry.coordinates()[1]);
      self.lon(self.layer.state().geometry.coordinates()[0]);

      self.changes = ko.computed(function () {
        // want to be notified of changes to these properties
        return self.selectedIcon() +
            self.iconColour() +
            self.selectedIconSize()[0] +
            self.paddleVisible() +
            self.labelVisible() +
            self.paddleColour() +
            self.labelText() +
            self.selectedTextSize()[0] +
            self.selectedAlignment()[0] +
            self.labelTextColor() +
            self.labelShadowColor() +
            self.lat() +
            self.lon() +
            self.iconVisible();
      });

      self.changes.subscribe(function () {
        // update layer observables and notify
        self.layer.name(self.labelText() || "New Marker");
        self.name(self.layer.name());

        self.layer.state().selectedicon(self.selectedIcon());
        self.layer.state().iconColour(self.iconColour());
        self.layer.state().iconSize(self.selectedIconSize()[0]);
        self.layer.state().visibilityOptions.iconVisible(self.iconVisible());
        
        self.layer.state().visibilityOptions.paddleVisible(self.paddleVisible());
        self.layer.state().paddleColour(self.paddleColour());
        
        self.layer.state().html(self.labelText());
        self.layer.state().visibilityOptions.labelVisible(self.labelVisible());
        self.layer.state().textSize(self.selectedTextSize()[0]);
        self.layer.state().textAlign(self.selectedAlignment()[0]);
        self.layer.state().geometry.coordinates([self.lon(), self.lat()]);
        self.layer.state().labelTextColor(self.labelTextColor());
        self.layer.state().textShadowColour(self.labelShadowColor());

        // remember this style for next time
        markerStyleTracker.saveStyleFromMarker(self.layer.state());

        app.trigger("layers:updated", [self.layer]);
      });

      app.on('marker:moved', self.onMarkerMoved);
    };

    self.deactivate = function () {
      app.off('marker:moved', self.onMarkerMoved);
    };

    self.getIcons = function () {
      var url = '/api/editor/icons';

      return http.get(url);
    };

    self.processIcons = function (response) {
      // group icons into category heirarchy
      var icons = response.data.icons;
      var categories = ko.utils.arrayMap(icons, function (icon) {
        return icon.categoryName;
      });

      var uniqueCategories = ko.utils.arrayGetDistinctValues(categories).sort();
      var categoriesLen = uniqueCategories.length;

      for (var i = 0; i < categoriesLen; i++) {
        var catName = uniqueCategories[i];
        var groupedIconsByCategory = {
          name: catName,
          icons: ko.observableArray([])
        };

        var categoryIcons = ko.utils.arrayFilter(icons, function (icon) {
          return icon.categoryName === catName;
        });

        ko.utils.arrayPushAll(groupedIconsByCategory.icons(), categoryIcons);

        self.icons.push(groupedIconsByCategory);
      }
    };

    self.onMarkerMoved = function (data) {
      if (self.layer.id() === data.id) {
        self.lat(data.newPos.lat);
        self.lon(data.newPos.lng);
      }
    };

      self.chooseIcon = function() {
          self.choosingIcon(true);

          return false;
      };

    self.setSelectedIcon = function (icon) {
        self.selectedIcon(icon.filePath);
        self.choosingIcon(false);

        return false;
    };

    self.toggleIconVisibility = function () {
      self.iconVisible(!self.iconVisible());
    };

    self.compositionComplete = function () {
      // initialise jquery plugins etc
      var picker = $('.color-picker-text').tinycolorpicker();
      var pickerIcon = $('.color-picker-icon').tinycolorpicker();
      var pickerMarker = $('.color-picker-marker').tinycolorpicker();
      var pickerShadow = $('.color-picker-shadow').tinycolorpicker({ "nocolor": true });

      picker.data().plugin_tinycolorpicker.setColor(self.labelTextColor());
      pickerShadow.data().plugin_tinycolorpicker.setColor(self.labelShadowColor());
      pickerIcon.data().plugin_tinycolorpicker.setColor(self.iconColour());
      pickerMarker.data().plugin_tinycolorpicker.setColor(self.paddleColour());

      picker.bind("change", function () {
        var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
        self.labelTextColor(newColour);
      });

      pickerShadow.bind("change", function () {
        var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
        self.labelShadowColor(newColour);
      });

      pickerIcon.bind("change", function () {
        var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
        self.iconColour(newColour);
      });

      pickerMarker.bind("change", function () {
        var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
        self.paddleColour(newColour);
      });
    };
  };

  return viewmodel;
});

